import { Component } from '@angular/core';

import {ViewChild}              from    '@angular/core';
import {FaceBookService}        from '../../providers/facebook-provider';
import {FirebaseService}        from '../../providers/firebase-provider';
import {UserService}            from '../../providers/userService-provider';

@Component({
    selector: 'page-login',
    templateUrl: 'login.route.html',
})
export class loginPage {
    
    constructor(
        public faceBookService: FaceBookService,
        public firebaseService: FirebaseService,
        private userService: UserService
    ) {

    }
    getRoute() {
        var ret = "profile";
        if (this.firebaseService.userStatus == null) ret= 'starter'; 
        else if (this.firebaseService.userStatus.uid == undefined) ret = 'login';        
        return ret;
    }

}




// WEBPACK FOOTER //
// ./src/app/feature/loginModule/pages/route/login.route.ts